export const hasSetting = (setting, value) => {
  if (!value) {
    return true
  }
    const val = Array.isArray(value) ? value : [value]
    return val.some(item => Boolean(Number(setting[item])))
}
